define('Header.View.Extension', [
  'Header.View',

  'Backbone',
  'SC.Configuration',
  'jQuery',
  'Utils',
  'underscore'
], function (
  HeaderView,

  Backbone,
  Configuration,
  jQuery,
  Utils,
  _
) {
  'use strict';

  _.extend(HeaderView.prototype, {
    getContext: _.wrap(HeaderView.prototype.getContext, function (fn) {
      var context = fn.apply(this, _.toArray(arguments).slice(1));
      var header = Configuration.get('header');
      context.phone = header.contactphone;
      context.address = header.contactaddress;
      context.hours = header.contacthours;

      return context;
    })
  });
});
